export default function getModules() {
    return {
      prebidScript: 'https://micro.rubiconproject.com/prebid/dynamic/15518.js',
      useLimitedAds: true,
      useSeenthis: true,
      usePlacementObserver: true,
      useObserverWithoutUniqueId: true,
      useLoadDMByAdsLib: true,
      useGLazyLoad: ['responsive_1', 'top_ad'],
      usePlacementCheck: true,
      useStats: true,
      useVideoStats: true,
    };
  }
  